module.exports = __webpack_public_path__ + "img/D201802_3.6fc9dddd.jpg";